// extracted by mini-css-extract-plugin
module.exports = {"aboutMe":"About_aboutMe__Xy540","container":"About_container__vm32Q","text":"About_text__AAQxL","photo":"About_photo__mSSn5","dp":"About_dp__2_G67"};